module.exports = __webpack_public_path__ + "right.png?2dcf0d60361236255d21cc75ba77913b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/LCStudies/right.png
// module id = 192
// module chunks = 0